import React, { useState } from "react";
import ResizableCell from "../../Utility/ResizableCell";
import { Link, useNavigate, useParams } from "react-router-dom";
import useDownloader from "react-use-downloader";
import { toast } from "react-toastify";
import { getUrlFromS3 } from "../api";
import { useGetAllCategories } from "../../Classification/api";
import { findTitleById } from "../../Classification/utils";
export default function PMIXTable({ reports, handleCategoryChange, restaurant_id }) {
  const { id } = useParams();
  const { download, isInProgress } = useDownloader();
  const navigate = useNavigate();
  const [editableCell, setEditableCell] = useState(null);
  const [category, setCategory] = useState(null);
  const [subcategory, setSubcategory] = useState(null);

  const { data: allCategories, isLoading } = useGetAllCategories({
    restaurant_id: restaurant_id,
  });
  if (!reports || reports.length === 0) {
    return <p>No reports available</p>;
  }
  const oheaders = Object.keys(reports[0]).filter(
    (key) => key !== "_id" && key !== "product_id" && key !== "report_id"
  );
  // if oheaders doesn't have subcategory and subcategory_confidence, add them
  if (!oheaders.includes("subcategory")) {
    oheaders.push("subcategory");
  }
  if (!oheaders.includes("subcategory_confidence")) {
    oheaders.push("subcategory_confidence");
  }
  if (!oheaders.includes("sub_subcategory")) {
    oheaders.push("sub_subcategory");
  }
  if (!oheaders.includes("sub_subcategory_confidence")) {
    oheaders.push("sub_subcategory_confidence");
  }

  const desiredOrder = [
    "Menu Item",
    "category",
    "category_confidence",
    "subcategory",
    "subcategory_confidence",
    "sub_subcategory",
    "sub_subcategory_confidence",
    "Item Qty",
    "Avg Price",
    "Discount Amount",
    "Gross Amount",
    "Refund",
    "Net Amount",
    "extracted_date",
    "report_date",
  ];

  // Filter the headers based on the desired order
  const headers = desiredOrder.filter((header) => oheaders.includes(header));

  const handleEditClick = (e, id) => {
    setEditableCell(id);
  };

  const handleEditableCellBlur = (id) => {
    setEditableCell(null);
    handleCategoryChange(id, category, subcategory);
  };

  const downloadHandler = async (restaurant_id, report_date, report_type) => {
    try {
      const response = await getUrlFromS3(
        restaurant_id,
        report_date,
        report_type
      );
      if (response?.file_url === undefined) {
        toast.error("File not available");
        return;
      }
      download(response.file_url, response.file_name);
    } catch (error) {
      toast.error("File not available");
    }
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-striped table-hover table-bordered shadow-sm table-responsive table-stack">
        <thead>
          <tr>
            {headers.map((header) => (
              <th
                key={header}
                style={{
                  textAlign: "center",
                  textTransform: "capitalize",
                  verticalAlign: "middle",
                }}
              >
                <ResizableCell>{header.replace(/_/g, " ")}</ResizableCell>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reports.map((row) => (
            <React.Fragment key={row.item_uuid}>
              <tr>
                {headers.map((header) => (
                  <td
                    data-label={header.replace(/_/g, " ")}
                    style={{
                      textAlign: "center",
                    }}
                    key={header}
                  >
                    {editableCell === row._id &&
                    (header == "category" || header == "subcategory") ? (
                      <input
                        className="form-control mx-auto"
                        type="text"
                        style={{ width: "80%" }}
                        defaultValue={row[header]}
                        onChange={(e) => {
                          if (header == "subcategory")
                            setSubcategory(e.target.value);
                          else setCategory(e.target.value);
                        }}
                        onBlur={(e) => {
                          e.stopPropagation();
                          handleEditableCellBlur(row.product_id);
                        }}
                      />
                    ) : header == "Menu Item" ? (
                      <Link
                        to={`/restaurants/reports/report-details/${row.report_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-body"
                        style={{ textDecoration: "underline" }}
                      >
                        {row[header]}
                      </Link>
                    ) : header === "category" ||
                      header === "subcategory" ||
                      header === "sub_subcategory" ? (
                      <>
                        {allCategories && !isLoading
                          ? findTitleById(
                              allCategories?.categories.filter(
                                (category) => category.type == "Menu"
                              ),
                              row[header]
                            )
                          : row[header]}
                      </>
                    ) : typeof row[header] === "boolean" ? (
                      row[header] ? (
                        "Yes"
                      ) : (
                        "No"
                      )
                    ) : (
                      row[header]
                    )}
                  </td>
                ))}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}
